export default [
  {
    path: '/main/integrador/integrator-install-instructions',
    meta: {
      tag: 'list_integrator_install_instructions',
      name: 'Instruções de Instalação',
      breadcrumb: 'Instruções de Instalação',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "integrator-install-instructions-list" */ '@/views/main/settings/integrador/install-instructions/Index.vue'),
    children: [
      {
        path: '',
        name: 'listintegratorinstallinstructions',
        meta: {
          tag: 'list_integrator_install_instructions',
          menu: 'settings',
          name: 'Instruções de Instalação'
        },
        component: () => import(/* webpackChunkName: "integrator-install-instructions-list" */ '@/views/main/settings/integrador/install-instructions/List.vue'),
      },
      {
        path: '/main/integrador/integrator-install-instructions/add',
        name: 'addintegratorinstallinstructions',
        meta: {
          tag: 'add_integrator_install_instructions',
          menu: 'settings',
          name: 'Adicionar | Instruções de Instalação',
          breadcrumb: 'Adicionar Instruções de Instalação'
        },
        component: () => import(/* webpackChunkName: "integrator-install-instructions-add" */ '@/views/main/settings/integrador/install-instructions/Add.vue')
      },
      {
        path: '/main/integrador/integrator-install-instructions/:id',
        name: 'editintegratorinstallinstructions',
        meta: {
          tag: 'edit_integrator_install_instructions',
          menu: 'settings',
          name: 'Editar | Instruções de Instalação',
          breadcrumb: 'Editar Instruções de Instalação'
        },
        component: () => import(/* webpackChunkName: "integrator-install-instructions-edit" */ '@/views/main/settings/integrador/install-instructions/Edit.vue')
      }
    ]
  }
]
